module.exports = "/_next/static/images/e641eb23db0cdb45ef2d0c61c0935804-nucommunity-md@2x.jpg.webp";